module.exports = new __parcel__URL__("bfg.5fa19d35.avif").toString();